import type {Values} from '@wix/devzai-utils-common';
import {DoppeBusinessEntity} from './doppe-business-entity';
import {DoppeAutoProductType} from './doppe-auto-product-type';

export const DoppeProductsExternalDataSourceType = {
    LatestWixProducts: 'LatestWixProducts',
    LatestHoppProducts: 'LatestHoppProducts',
    WixProductsByCategories: 'WixProductsByCategories',
    HoppProductsByCategories: 'HoppProductsByCategories',
    WixBestSellerProducts: 'WixBestSellerProducts',
    HoppBestSellerProducts: 'HoppBestSellerProducts',
} as const;

export type DoppeProductsExternalDataSourceType = Values<typeof DoppeProductsExternalDataSourceType>;

export type DoppeProductsExternalDataSource =
    | {
        type: typeof DoppeProductsExternalDataSourceType.LatestWixProducts;
    }
    | {
        type: typeof DoppeProductsExternalDataSourceType.LatestHoppProducts;
    }
    | {
        type: typeof DoppeProductsExternalDataSourceType.WixProductsByCategories;
        categoryIds: string[];
    }
    | {
        type: typeof DoppeProductsExternalDataSourceType.HoppProductsByCategories;
        categoryIds: string[];
    }
    | {
        type: typeof DoppeProductsExternalDataSourceType.WixBestSellerProducts;
    }
    | {
        type: typeof DoppeProductsExternalDataSourceType.HoppBestSellerProducts;
    };

export function doppeProductsExternalDataSourceResolveBusinessEntityReferences(
    externalDataSource: DoppeProductsExternalDataSource
) {
    switch (externalDataSource.type) {
        case DoppeProductsExternalDataSourceType.LatestWixProducts: {
            return {businessEntity: DoppeBusinessEntity.WixAutoProductsList, id: DoppeAutoProductType.Latest}
        }
        case DoppeProductsExternalDataSourceType.LatestHoppProducts: {
            return {businessEntity: DoppeBusinessEntity.HoppAutoProductsList, id: DoppeAutoProductType.Latest}
        }
        case DoppeProductsExternalDataSourceType.WixProductsByCategories: {
            return {businessEntity: DoppeBusinessEntity.WixAutoProductsList, id: DoppeAutoProductType.Categories, metadata: {categoryIds: externalDataSource.categoryIds}}
        }
        case DoppeProductsExternalDataSourceType.HoppProductsByCategories: {
            return {businessEntity: DoppeBusinessEntity.HoppAutoProductsList, id: DoppeAutoProductType.Categories, metadata: {categoryIds: externalDataSource.categoryIds}}
        }
        case DoppeProductsExternalDataSourceType.WixBestSellerProducts: {
            return {businessEntity: DoppeBusinessEntity.WixAutoProductsList, id: DoppeAutoProductType.BestSellers}
        }
        case DoppeProductsExternalDataSourceType.HoppBestSellerProducts: {
            return {businessEntity: DoppeBusinessEntity.HoppAutoProductsList, id: DoppeAutoProductType.BestSellers}
        }
    }
}